export const SUPPORT_URL = "https://www.nl-ix.net/about/contact/";
export const SUPPORT_EMAIL = "support@nl-ix.net";
export const SUPPORT_PHONE = "+31 (0)70 3120710";

export default function ContactText({contactSales = false}: {contactSales?: boolean}) {
    return (
        <>
            You can contact our {contactSales ? "sales team " : (
                <>
                    <a href={SUPPORT_URL} target="_blank" rel="noreferrer">
                        customer care and support desk
                    </a>
                </>
            )}
            {" "}via email at{" "}
            <a href={`mailto:${contactSales ? "sales@nl-ix.net" : SUPPORT_EMAIL}`}>
                {contactSales ? "sales@nl-ix.net" : SUPPORT_EMAIL}
            </a>{" "}
            or by phone to our support team on  <a href={`tel:${SUPPORT_PHONE}`}>{SUPPORT_PHONE}</a>.
        </>
    );
}
